/* eslint-disable no-param-reassign */
import axiosRetry from 'axios-retry';
import createAxiosIntance from './requester';
import utils from './utils';
import authentication from './authentication';
import api from './api';

export {
  axiosRetry, utils, authentication, createAxiosIntance,
};

const StRequests = api;
export default StRequests;

